/* Admin: monthly Excel of every completed-invoice change — who, what, slip uploaded, who acknowledged. */
import { useState } from "react";
import axios from "axios";
import { FileWarning, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { API, getAuthHeader } from "@/App";

export const CorrectionReportButton = () => {
  const [month, setMonth] = useState(() => new Date().toISOString().slice(0, 7));
  const [busy, setBusy] = useState(false);
  let isAdmin = false;
  try { isAdmin = JSON.parse(localStorage.getItem("user") || "{}").role === "admin"; } catch { /* not logged in */ }
  if (!isAdmin) return null;
  const go = async () => {
    setBusy(true);
    try {
      const r = await axios.get(`${API}/order-register/corrections/report.xlsx`, { headers: getAuthHeader(), params: { month }, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a"); a.href = url; a.download = `Invoice Corrections ${month}.xlsx`; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 30000);
    } catch (e) { toast.error("Could not download the correction report"); }
    setBusy(false);
  };
  return (
    <span className="inline-flex h-7 items-center gap-1 rounded border px-1.5 text-[11px]" data-testid="or-correction-report">
      <FileWarning className="h-3.5 w-3.5 text-amber-600" />
      <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="h-6 w-[110px] bg-transparent text-[11px]" data-testid="or-correction-month" />
      <button type="button" onClick={go} disabled={busy} className="font-semibold text-amber-700" title="Every completed-invoice change this month: who, what, slip uploaded, who acknowledged" data-testid="or-correction-download">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Corrections Excel"}</button>
    </span>
  );
};
